export enum IconType {
  XLS,
  PDF,
  TEXT,
  XLS_TEXT
}
